import React from 'react';
import { EditPage } from '../edit_page/EditPage';
import AssetCycleRunForm from '../AssetCycleRunForm';
import { connect } from 'react-redux';

function NewAssetCycleEventPage({ history, fetching }) {
	return (
		<EditPage
			title="Create Asset Count Event"
			formComponentProps={{
				formData: {},
				isEditForm: false,
				onSuccess: (rec) => history.push(`/buyer/assetcycleevents/detail/${rec.id}/details`),
			}}
			// fetching={fetching}
			FormComponent={AssetCycleRunForm}
		/>
	);
}

const mapStateToProps = (state) => ({
	// fetching: state.cycle_events.fetching,
});

export default connect(mapStateToProps)(NewAssetCycleEventPage as any);
